import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {};

export const cardContent: SxStyle = {
  '&.MuiCardContent-root:last-child': { paddingBottom: 1 },
};

export const divider: SxStyle = {
  my: 0.5,
};
